module.exports = __webpack_public_path__ + "media/images/home/deliveroo-10eb1528ecbf2f4c17ddd4e38636d656.png";